"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSelect = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var react_1 = require("react");
var theme_1 = require("../../theme");
var Checkbox_1 = require("../Checkbox");
var TextInput_1 = require("../TextInput");
var Typography_1 = require("../Typography");
var SearchSelect = function (_a) {
    var _b;
    var options = _a.options, value = _a.value, disabled = _a.disabled, placeholder = _a.placeholder, onChange = _a.onChange, _c = _a.editable, editable = _c === void 0 ? true : _c, icon = _a.icon, dataTestId = _a["data-testid"], ariaLabel = _a["aria-label"], _d = _a.notFoundText, notFoundText = _d === void 0 ? 'Nothing found' : _d, branding = _a.branding, loading = _a.loading, onFilter = _a.onFilter;
    var bgColors = (0, theme_1.useBackgroundColors)(branding);
    var bgStateColors = (0, theme_1.useBackgroundStateColors)(branding);
    var bgStateActiveColors = (0, theme_1.useBackgroundStateActiveColors)(branding);
    var borderColors = (0, theme_1.useBorderColors)(branding);
    var textInputRef = (0, react_1.useRef)(null);
    var dropDownRef = (0, react_1.useRef)(null);
    var optionsRef = (0, react_1.useRef)([]);
    var _e = (0, react_1.useState)(''), query = _e[0], setQuery = _e[1];
    var _f = (0, react_1.useState)(false), open = _f[0], setOpen = _f[1];
    var _g = (0, react_1.useState)(value), selectedOption = _g[0], setSelectedOption = _g[1];
    var _h = (0, react_1.useState)((_b = value === null || value === void 0 ? void 0 : value.label) !== null && _b !== void 0 ? _b : ''), selectedValue = _h[0], setSelectedValue = _h[1];
    (0, react_1.useEffect)(function () {
        var _a;
        if (value && value !== selectedOption) {
            setSelectedOption(value);
            setSelectedValue((_a = value === null || value === void 0 ? void 0 : value.label) !== null && _a !== void 0 ? _a : '');
        }
    }, [value, selectedOption]);
    var filteredOptions = (0, react_1.useMemo)(function () {
        if (!query || query.trim().length === 0) {
            return options;
        }
        else if (onFilter) {
            return onFilter(query) || [];
        }
        return options.filter(function (option) {
            return option.label.toLowerCase().includes(query.trim().toLowerCase());
        });
    }, [query, options]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (!dropDownRef.current) {
            return;
        }
        var dropdown = dropDownRef.current;
        var textInput = (_a = textInputRef.current) === null || _a === void 0 ? void 0 : _a.dimensions();
        if (window.innerHeight <
            ((_b = dropdown.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.bottom) + textInput.offsetHeight) {
            dropdown.style.top = "-".concat(dropdown.offsetHeight + textInput.offsetHeight / 2, "px");
        }
        else {
            dropdown.style.top = '100%';
        }
    }, [dropDownRef, textInputRef, open]);
    var handleTextInputChange = function (input) {
        setQuery(input);
        if (!input.trim()) {
            setSelectedOption(undefined);
            setSelectedValue('');
            onChange === null || onChange === void 0 ? void 0 : onChange(undefined);
        }
        else {
            setSelectedValue(input);
        }
    };
    var handleChange = function (option) { return function () {
        setSelectedOption(option);
        setSelectedValue(option.label);
        setQuery('');
        onChange === null || onChange === void 0 ? void 0 : onChange(option);
        setOpen(false);
    }; };
    var handleFocus = function () {
        setOpen(true);
    };
    var handleButtonClick = function () {
        var _a, _b;
        if (open) {
            (_a = textInputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            setOpen(false);
        }
        else {
            if (editable) {
                (_b = textInputRef.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
            handleFocus();
        }
    };
    var handleOutsideClick = function (e) {
        var _a, _b, _c;
        if (!((_a = textInputRef === null || textInputRef === void 0 ? void 0 : textInputRef.current) === null || _a === void 0 ? void 0 : _a.isClicked())) {
            setOpen(false);
        }
        else if ((_b = dropDownRef === null || dropDownRef === void 0 ? void 0 : dropDownRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target)) {
            var datesClicked = (_c = optionsRef.current) === null || _c === void 0 ? void 0 : _c.filter(function (current) { return current && current.contains(e.target); });
            setOpen(datesClicked.length <= 0);
        }
        else {
            setOpen(false);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "squid-relative" }, { children: [(0, jsx_runtime_1.jsx)(TextInput_1.TextInput, { loading: loading, placeholder: placeholder, disabled: disabled, icon: icon, addonVariant: "contained", addonIcon: open ? 'ChevronUp' : 'ChevronDown', addonPosition: "right", onClickAddon: handleButtonClick, onFocus: handleFocus, onChange: editable ? handleTextInputChange : undefined, onOutsideClick: handleOutsideClick, value: selectedValue, forwardedRef: textInputRef, "data-testid": dataTestId, editable: loading ? false : editable, "aria-label": ariaLabel }), !loading && open && ((0, jsx_runtime_1.jsx)("div", __assign({ ref: dropDownRef, className: (0, classnames_1.default)("\n          squid-absolute \n          squid-w-full \n          squid-max-h-60 \n          squid-overflow-y-auto \n          squid-z-50 \n          squid-mt-2 \n          squid-flex \n          squid-flex-col \n          squid-p-component-dropdown-menu-padding \n          squid-gap-0.5 \n          squid-border \n          squid-rounded-component-dropdown-menu-border-radius \n          squid-core-shadow-elevation-sm-0-color\n          ", bgColors.base, borderColors.base), role: "menu", "aria-orientation": "vertical", "aria-labelledby": "menu-button" }, { children: filteredOptions.length === 0 ? ((0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ as: "div", strong: false, className: "squid-relative squid-cursor-default squid-select-none squid-py-2", color: "base" }, { children: notFoundText }))) : (filteredOptions.map(function (option, index) {
                    var _a;
                    var isSelected = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) === option.label &&
                        (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === option.value;
                    return ((0, jsx_runtime_1.jsxs)("div", __assign({ ref: function (ref) {
                            optionsRef.current[index] = ref;
                        }, role: "menuitem", "aria-label": option.label, className: (0, classnames_1.default)("\n                      squid-flex \n                      squid-py-2 \n                      squid-px-2.5 \n                      squid-gap-0.5 \n                      squid-items-center \n                      squid-rounded-component-menu-item-border-radius \n                      ", (_a = {},
                            _a[bgStateActiveColors.base] = isSelected,
                            _a), bgStateColors.base), onClick: handleChange(option), "data-testid": "".concat(dataTestId).concat(option.value) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "squid-flex-1" }, { children: (0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ strong: isSelected, color: "base" }, { children: option.label })) })), (0, jsx_runtime_1.jsx)(Checkbox_1.Radio, { checked: isSelected })] }), "".concat(option.label, "_").concat(option.value || '')));
                })) })))] })));
};
exports.SearchSelect = SearchSelect;
